import { getSystemMaterials } from "@/api/spec-common/material";
import { MaterialCategory, MaterialCode, MaterialInLibrary, PMaterial } from "@/commons/interface/speccommon/material";
import { useEffect, useImperativeHandle, useState } from "react";
import "./material-lib.less";
import { ReactComponent as ArrowDownSvg } from "@/commons/icons/arrow/arrow-down-black.svg";
import MultiSelect from "@/commons/widget/select/multi-select";
import ContextMenuWrapper from "@/commons/widget/context-menu/context-menu-wrapper";
import { Button, Input, Skeleton, message } from "antd";
import { ParamNameUtil, ParamUnits } from "@/commons/utils/unit";
import { ReactComponent as CheckBoxCheckedSvg } from '@/commons/icons/check-box/check-box-checked.svg';
import { ReactComponent as CheckBoxSvg } from '@/commons/icons/check-box/check-box.svg';
import { useParams } from "react-router-dom";
import { floatVerification } from "@/commons/utils/antd-input";

interface IProp {
    width: number;
    goBack: () => void
    onAddFromLib: (markIds: string[]) => void
    onAddSelfdefine: (material: PMaterial) => void
}
export default function MaterialLib(props: IProp, ref) {
    const { projectUuid } = useParams();
    const [matCategorys, setMatCategorys] = useState<MaterialCategory[]>([]);
    const [matCodes, setMatCodes] = useState<MaterialCode[]>([]);
    const [matMarks, setMatMarks] = useState<MaterialInLibrary[]>([]);
    const [selCategory, setSelCategory] = useState<MaterialCategory>(); // 当前材料类别
    const [selCode, setSelCode] = useState<MaterialCode>(); // 当前材料规范
    const [selMarkIds, setSelMarkIds] = useState<string[]>([]);

    const [categoryVisiable, setCategoryVisiable] = useState<boolean>(false); // 库导入分类的下拉框是否可见
    const [codeVisiable, setCodeVisiable] = useState<boolean>(false); // 库导入标准的下拉框是否可见

    const [isSelfDefine, setIsSelfDefine] = useState<boolean>(false); // 是否选择了自定义

    const [selMark, setSelMark] = useState<MaterialInLibrary>();
    const [newMaterial, setNewMaterial] = useState<PMaterial>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [markVisiable, setMarkVisiable] = useState<boolean>(false); // 库导入等级的下拉框是否可见

    useImperativeHandle(ref, () => ({
        handleInsert: onAddConfirm,
    }))

    useEffect(() => {
        setLoading(true);
        getSystemMaterials().then((res) => {
            let categorys: MaterialCategory[] = res.data || [];
            setMatCategorys(categorys);
            if (categorys.length > 0) {
                setSelCategory(categorys[0]);
                setMatCodes(categorys[0].codes || []);
                if ((categorys[0].codes || []).length > 0) {
                    setSelCode(categorys[0].codes[0]);
                    setMatMarks(categorys[0].codes[0].libraries || []);
                    if (categorys[0].codes[0].libraries.length > 0) {
                        setSelMark(categorys[0].codes[0].libraries[0]);
                    }
                }
            }
        }).catch(err => {
            message.error("获取数据失败");
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    useEffect(() => {
        if (!selCategory) return;
        let categoryIdx = matCategorys.findIndex(item => item.id == selCategory.id);
        let matCodes = matCategorys[categoryIdx].codes;
        setMatCodes(matCodes);
        setSelCode(matCodes[0]);
        setMatMarks(matCodes[0].libraries);
        setSelMark(matCodes[0].libraries[0]);
        setNewMaterial({ ...newMaterial, category: selCategory.id, categoryName: selCategory.name, code: matCodes[0].code, mark: matCodes[0].libraries[0].mark, params: matCodes[0].libraries[0].params });
        setCategoryVisiable(false);
    }, [selCategory])

    useEffect(() => {
        if (!selCode) return;
        let categoryIdx = matCategorys.findIndex(item => item.id == selCategory.id);
        let codeIdx = matCodes.findIndex(item => item.id == selCode.id);
        let matMarks = matCategorys[categoryIdx].codes[codeIdx].libraries;
        setMatMarks(matMarks);
        setSelMark(matMarks[0]);
        setNewMaterial({ ...newMaterial, code: matCodes[0].code, mark: matCodes[0].libraries[0].mark, params: matCodes[0].libraries[0].params });
        setCodeVisiable(false);
    }, [selCode])

    const onAddConfirm = () => {
        props.onAddFromLib(selMarkIds);
    }

    useEffect(() => {
        if (!selMark) return;
        // 创建一个 params 对象的浅拷贝，并更新其中的数值属性
        const updatedParams = { ...selMark.params };
        for (const key in updatedParams) {
            if (typeof updatedParams[key] === 'number') {
                updatedParams[key] /= 1000000;
            }
        }
        // 使用更新后的 params 对象来设置 newMaterial 状态
        setNewMaterial({
            ...newMaterial,
            mark: selMark.mark,
            params: updatedParams
        });
        setCodeVisiable(false);
    }, [selMark])

    const handleChangeParams = (key: string, value: string) => {
        const newValueStr = floatVerification(value);
        // 检查newValueStr是否为空或者不是一个合法的数字字符串
        if (newValueStr === '') {
            message.error("请输入正确的数值");
            return;
        }
        // 将字符串转换为数字，如果包含小数点则转换为浮点数，否则转换为整数
        const newValue = newValueStr.includes('.') ? parseFloat(newValueStr) : parseInt(newValueStr, 10);
        // 更新物料参数
        const updatedParams = { ...newMaterial.params, [key]: newValue };
        setNewMaterial({ ...newMaterial, params: updatedParams });
    }

    return (
        <div className="material-lib">
            <div className="common-box select-box">
                <div className="select-box-item">
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">{selCategory?.name}</div>
                                <ArrowDownSvg />
                            </div>
                        }
                        visible={categoryVisiable}
                        onVisibleChange={(v) => setCategoryVisiable(v)}
                        classname="select-area"
                        width={props.width - 32 - 4}
                    >
                        <div className="project-material-select-box">
                            {matCategorys?.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => { setSelCategory(item); setCategoryVisiable(false) }}
                                        className="project-material-select-box-item"
                                    >
                                        {item.name}
                                    </div>
                                );
                            })}
                        </div>
                    </ContextMenuWrapper>
                </div>
                <div className="select-box-item">
                    <ContextMenuWrapper
                        container={
                            <div className="select-content">
                                <div className="ellipsis">{selCode?.code}</div>
                                <ArrowDownSvg
                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                />
                            </div>
                        }
                        visible={codeVisiable}
                        onVisibleChange={(v) => setCodeVisiable(v)}
                        classname="select-area"
                        width={props.width - 32 - 4}
                    >
                        <div className="project-material-select-box">
                            {matCodes?.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            setSelCode(item)
                                            setCodeVisiable(false);
                                        }}
                                        className="project-material-select-box-item"
                                    >
                                        {item.code}
                                    </div>
                                )
                            })}
                        </div>
                    </ContextMenuWrapper>
                </div>
            </div>
            <div className="library-box">
                <div className="common-box type-box">
                    <div className="type-box-title">
                        型号
                        <div className="self-define">
                            {isSelfDefine ? <CheckBoxCheckedSvg style={{ cursor: 'pointer' }} onClick={() => setIsSelfDefine(false)} /> : <CheckBoxSvg style={{ cursor: 'pointer' }} onClick={() => setIsSelfDefine(true)} />}
                            <span style={{ width: '4px' }}></span>
                            自定义
                        </div>
                    </div>
                    {isSelfDefine && (
                        <>
                            <div className="self-define-box">
                                <div className="name-item" style={{ width: props.width - 32 - 6 }}>
                                    <div className="name-item-title">名称</div>
                                    <Input
                                        placeholder="请输入名称"
                                        value={newMaterial?.name || ""}
                                        onChange={(e) => {
                                            setNewMaterial({ ...newMaterial, name: e.target.value });
                                        }}
                                    ></Input>
                                </div>
                                <div className="name-item" style={{ width: props.width - 32 - 6 }}>
                                    <div className="name-item-title">
                                        {selCategory?.name}等级
                                    </div>
                                    <ContextMenuWrapper
                                        container={
                                            <div className="select-content">
                                                <div className="ellipsis">
                                                    {selMark?.mark + (isNaN(selMark?.thickMin) ? "" : "-" + selMark?.thickMin) + (isNaN(selMark?.thickMax) ? "" : "-" + selMark?.thickMax)}
                                                </div>
                                                <ArrowDownSvg
                                                    style={{ marginLeft: "4px", flexShrink: 0 }}
                                                />
                                            </div>
                                        }
                                        visible={markVisiable}
                                        onVisibleChange={(v) => setMarkVisiable(v)}
                                        classname="select-area"
                                        width={props.width - 32 - 6}
                                    >
                                        <div className="project-material-select-box">
                                            {matMarks.map(
                                                (item, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            onClick={() => {
                                                                setSelMark(item)
                                                                setMarkVisiable(false)
                                                            }}
                                                            className="project-material-select-box-item"
                                                        >
                                                            {item.mark + (isNaN(item?.thickMin) ? "" : "-" + item?.thickMin) + (isNaN(item?.thickMax) ? "" : "-" + item?.thickMax)}
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </ContextMenuWrapper>
                                </div>
                                <div className="common-box param-box" style={{ width: props.width - 32 - 6 }}>
                                    <div className="param-box-title">材料参数</div>
                                    {newMaterial &&
                                        Object.entries(newMaterial.params).filter(([param, value]) => { return (ParamNameUtil[param] != null) && (ParamUnits[param] != null) }).map(([param, value]) => (
                                            <div className="param-item" key={param} >
                                                <div className="param-item-title">
                                                    {ParamNameUtil[param] != null ? `${ParamNameUtil[param]}` : ""}
                                                    {ParamUnits[param] != null ? `(${ParamUnits[param]})` : ""}
                                                </div>
                                                <Input
                                                    type="number"
                                                    placeholder={`请输入${ParamNameUtil[param]}`}
                                                    value={value || ""}
                                                    onChange={(e) => handleChangeParams(param, e.target.value)}
                                                />
                                            </div >
                                        ))}
                                </div>
                            </div>
                            {/* < div className='footer' >
                                <Button className='btn add' onClick={() => props.onAddSelfdefine({ ...newMaterial, projectUuid: projectUuid, markId: selMark.id, category: selCategory.id, code: selCode.code })}>添加6</Button>
                                <Button className='btn cancel' onClick={() => props.goBack()}>取消</Button>
                            </div > */}
                            <div className='bottom-footer'>
                                <Button className='btn-save' onClick={() => props.onAddSelfdefine({ ...newMaterial, projectUuid: projectUuid, markId: selMark.id, category: selCategory.id, categoryName: selCategory.name, code: selCode.code })}>确认</Button>
                                <Button className='btn-cancel' onClick={() => props.goBack()}>取消</Button>
                            </div>
                        </>
                    )}
                    {!isSelfDefine && (
                        <>
                            <Skeleton active loading={loading}>
                                <div className="type-box-list">
                                    {matMarks && (
                                        <MultiSelect
                                            width={props.width - 32 - 2}
                                            selectedKeys={(selMarkIds || []).map((item) => item)}
                                            options={matMarks.map((item) => {
                                                return {
                                                    key: item.id.toString(),
                                                    label:
                                                        item.mark + " " + (isNaN(item?.thickMin) ? "" : item?.thickMin) + (isNaN(item?.thickMax) ? "" : "-" + item?.thickMax)
                                                }
                                            })}
                                            handleSelectItem={(key: string) => {
                                                if (selMarkIds.includes(key)) {
                                                    setSelMarkIds(selMarkIds.filter(item => item !== key));
                                                    return;
                                                }
                                                setSelMarkIds([...selMarkIds, key]);
                                            }}
                                        />
                                    )}
                                </div>
                            </Skeleton>
                            {/* <div className='bottom-footer'>
                                <Button className='btn-save' onClick={onAddConfirm} loading={loading}>确认</Button>
                                <Button className='btn-cancel' onClick={() => props.goBack()}>取消</Button>
                            </div> */}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}